export const Today = new Date();
export const Tomorrow = new Date(Today.getTime() + 24 * 60 * 60 * 1000);
